import { jsx } from "react/jsx-runtime";
function PlayIcon() {
  const size = "24";
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: size,
      height: size,
      viewBox: `0 0 ${size} ${size}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx("path", { d: "M 5,5 20,12 5,20 Z", fill: "white " })
    }
  );
}
export {
  PlayIcon
};
//# sourceMappingURL=index.js.map
